// extracted by mini-css-extract-plugin
export var dropOver = "_mg-2";
export var dropValid = "_mg-1";
export var hidden = "_mg-3";
export var line = "_mg-0";